import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { useAdmin } from '../AdminContext';

function formatTimestamp(value) {
  if (!value) return 'Unknown';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString();
}

function RevenuePage() {
  const { revenueSummary, platformFees, revenueError } = useAdmin();
  const { refreshing, loadDashboard } = useOutletContext();

  return (
    <>
      <header className="admin-dashboard__header">
        <div>
          <h1 className="admin-dashboard__title">Revenue</h1>
          <p className="admin-dashboard__subtitle">
            Platform fee transactions across all fan purchases.
          </p>
        </div>
        <button
          type="button"
          className="admin-dashboard__refresh"
          onClick={() => loadDashboard({ silent: true })}
          disabled={refreshing}
        >
          {refreshing ? 'Refreshing...' : 'Refresh'}
        </button>
      </header>

      <div className="admin-revenue__cards">
        <div className="admin-revenue__card">
          <div className="admin-revenue__card-label">Total Collected (Spades)</div>
          <div className="admin-revenue__card-value">&#9824; {(revenueSummary.total_spades || 0).toLocaleString()}</div>
        </div>
        <div className="admin-revenue__card">
          <div className="admin-revenue__card-label">Total Collected (USD)</div>
          <div className="admin-revenue__card-value">${Number(revenueSummary.total_usd || 0).toFixed(2)}</div>
        </div>
        <div className="admin-revenue__card">
          <div className="admin-revenue__card-label">Total Transactions</div>
          <div className="admin-revenue__card-value">{(revenueSummary.transaction_count || 0).toLocaleString()}</div>
        </div>
      </div>

      <div className="admin-dashboard__card">
        {revenueError ? (
          <div className="admin-dashboard__empty">{revenueError}</div>
        ) : platformFees.length === 0 ? (
          <div className="admin-dashboard__empty">No platform fees collected yet.</div>
        ) : (
          <table className="admin-dashboard__table">
            <thead>
              <tr>
                <th>Fan</th>
                <th>Streamer</th>
                <th>Type</th>
                <th>Platform Cut (Spades)</th>
                <th>Platform Cut (USD)</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {platformFees.map((item) => (
                <tr key={`${item.ref_id}-${item.created_at}`}>
                  <td>{item.fan_username || item.fan_user_id || '-'}</td>
                  <td>{item.streamer_username || item.streamer_user_id || '-'}</td>
                  <td>{item.media_type || '-'}</td>
                  <td><span className="admin-dashboard__spades-value">&#9824; {(item.platform_fee_spades || 0).toLocaleString()}</span></td>
                  <td>${Number(item.platform_fee_usd || 0).toFixed(2)}</td>
                  <td>{formatTimestamp(item.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

export default RevenuePage;
